<script lang="ts">
import Vue from 'vue'
import Card from "@/components/ui/Card";
import Checkbox from "@/components/ui/Checkbox";
import TariffSetting from "@/views/insuranceProducts/components/TariffSetting.vue";
import tariffMixin from "@/views/insuranceProducts/mixins/tariffMixin"
import {petTypeLabels, petTypeIdMap} from "@/entities/insurance/config/pet-types";
import {petsPeriodLabels} from "@/entities/insurance/config/pets-insurance-periods";

export default Vue.extend({
    name: "TariffPetsItem",
    components: {TariffSetting, Checkbox, Card},
    props: {
        tariff: {
            type: Object,
        },
        companyName: {
            default() {
                return ''
            }
        }
    },
    mixins: [tariffMixin],
    data() {
        return {
            petTypeLabels,
            petTypeIdMap,
            petsPeriodLabels,
        }
    },
    methods: {
        getPetTypeLabel(id) {
            return petTypeLabels[petTypeIdMap[id]] || petTypeLabels[id] || id
        },
        getPetsPeriodLabel(id) {
            return petsPeriodLabels[id] || id
        },
    },
})
</script>

<template>
    <div>
        <Card>
            <div class="tariff-item d-flex justify-content-between flex-row align-items-center">
                <div class="column">
                    <div class="head">Тип продукту</div>
                    <div class="d-flex">
                        <div class="mr-2" v-if="$route.params.id">
                            <Checkbox v-model="tariff.isActive" @change="updateTariff(tariff)"></Checkbox>
                        </div>
                        <div>
                            Страхування тварин
                            <div v-if="tariff.parentCommission != null" class="text-muted small">Базова комісія: {{ tariff.parentCommission }}%</div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="head">Комісія/Знижка, %</div>
                    <div v-if="$route.params.id">
                        <TariffSetting v-model="tariff" :hide-discount="true">
                            Налаштування тарифів {{ companyName }} для точки продажу id: {{ tariff.userId }}
                        </TariffSetting>
                    </div>
                    <div v-else-if="isMainPartner">{{ tariff.commission - tariff.gap }}</div>
                    <div v-else>{{ tariff.commission }}</div>
                </div>
                <div class="column">
                    <div class="head">Тип тварини</div>
                    <div>{{ tariff.parameters && tariff.parameters.petTypes ? tariff.parameters.petTypes.map(id => getPetTypeLabel(id)).join(', ') : '' }}</div>
                </div>
                <div class="column">
                    <div class="head">Період страхування</div>
                    <div>{{ tariff.parameters && tariff.parameters.petsPeriods ? tariff.parameters.petsPeriods.map(id => getPetsPeriodLabel(id)).join(', ') : '' }}</div>
                </div>
            </div>
        </Card>
    </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/app/components/_tariff-item";

</style>